import React from 'react';

import { ColorsType, variables } from '../variables';

type DotsProps = {
  stroke?: ColorsType
}

export  const Dots: React.FC<DotsProps> = ({
   stroke= 'road-grey-700'
 }) => {
  return (
    <svg width="11" height="3" viewBox="0 0 11 3" fill="none" stroke={`${variables.colors[stroke]}`} xmlns="http://www.w3.org/2000/svg">
      <path d="M5.42942 1.81556C5.76413 1.81556 6.03548 1.54422 6.03548 1.2095C6.03548 0.874782 5.76413 0.603439 5.42942 0.603439C5.0947 0.603439 4.82336 0.874782 4.82336 1.2095C4.82336 1.54422 5.0947 1.81556 5.42942 1.81556Z"  stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.67184 1.81556C10.0066 1.81556 10.2779 1.54422 10.2779 1.2095C10.2779 0.874782 10.0066 0.603439 9.67184 0.603439C9.33712 0.603439 9.06578 0.874782 9.06578 1.2095C9.06578 1.54422 9.33712 1.81556 9.67184 1.81556Z"  stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.18699 1.81556C1.52171 1.81556 1.79305 1.54422 1.79305 1.2095C1.79305 0.874782 1.52171 0.603439 1.18699 0.603439C0.852275 0.603439 0.580933 0.874782 0.580933 1.2095C0.580933 1.54422 0.852275 1.81556 1.18699 1.81556Z"  stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
